import { CellPopover } from '@components/CellPopover';
import { ICellPopover } from '@hooks/useCellPopover';
import { Box, makeStyles, Typography } from '@material-ui/core';
import { IDespesa } from '@model/Despesa';
import React from 'react';

export type DespesaReciboPopoverProps = {
    despesa: IDespesa
    cellPopover: ICellPopover<IDespesa>
}

export function DespesaReciboPopover ({ despesa, cellPopover }: DespesaReciboPopoverProps) {
    const cls = useStyles();

    return (
        <CellPopover
            cellPopover={cellPopover}
        >
            <Box className={cls.root}>
                <Typography><b>Referente a:</b> {despesa.reciboReferencia}</Typography>
            </Box>
        </CellPopover>
    )
}

const useStyles = makeStyles(theme => ({
    root : {
        padding: theme.spacing(2)
    }
}));